<template>
  <div class="wrap">
    <div class="title">
      <router-link :to="{ name: 'create-kokuban-detail', params: { cloudConstructionId: $route.params.cloudConstructionId } }">
        {{ currentConstruction.cloud_construction_name }}
      </router-link>
      ＞黒板用データ
    </div>
    <div class="files-wrap">
      <div class="row">
        <div class="file-name head">
          ファイル名
        </div>
        <div class="modified-at head">
          最終更新日
        </div>
      </div>
      <div v-for="(file, idx) in fileList" :key="idx" class="row">
        <div class="file-name">{{ file.name }}</div>
        <div class="modified-at">{{ formatLastModified(file.lastModified) }}</div>
      </div>
    </div>
    <div class="drop-area-wrap">
      <form enctype="multipart/form-data">
        <div class="drop-area"
             :class="{ enter: isEnter }"
             @dragenter="isEnter = true"
             @dragleave="isEnter = false"
             @dragover.prevent
             @drop.prevent="filesUpload($event.dataTransfer.files)">
          ドラッグ&amp;ドロップで追加<br />
          または<br />
          <div class="file-ref-btn-wrap">
            <input type="file"
                   class="file-input"
                   @change="filesUpload($event.target.files)"
                   multiple />
            <span class="file-ref-btn">選択して追加</span>
          </div>
        </div>
      </form>
    </div>
    <div class="upload-wrap" v-if="uploadFiles.length !== 0">
      <div v-for="(uploadFile, idx) in uploadFiles" :key="idx" class="row">
        <div class="file-name">{{ uploadFile.file.name }}</div>
        <div class="upload-status"><span :class="uploadFile.status !== 'none' ? uploadFile.status : ''"></span></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));

export default {
  name: 'Input',
  props: {
    currentConstruction: Object,
    fileList: Array
  },
  data() {
    return {
      isEnter: false,
      uploadFiles: []
    }
  },
  computed: {
    fileListSize() {
      let fileSize = 0;
      this.fileList.forEach(file => {
        // byte
        fileSize = fileSize + file.size;
      });
      return fileSize;
    },
    isUploadFinished() {
      // アップロードされたファイルの中で、ステータスがcompleteになっているものが
      // ファイルリストの中に含まれているかチェックする
      // TODO 上書きのときはどうしよう
      const uploadCompletedFiles = this.uploadFiles.filter(uploadFile => uploadFile.status === 'complete');
      for (var i = 0; i < uploadCompletedFiles.length; i++) {
        const uploadCompletedFile = uploadCompletedFiles[i];
        if (this.fileList.find(file => file.name === uploadCompletedFile.file.name) === undefined) {
          return false;
        }
      }
      return true;
    }
  },
  methods: {
    async filesUpload(targetFiles) {
      // s3にファイルをアップロード
      this.uploadFiles = [];
      targetFiles.forEach(file => {
        this.uploadFiles.push({ file: file, status: 'none' });
      });
      for (var i = 0; i < this.uploadFiles.length; i++) {
        const uploadFile = this.uploadFiles[i]
        try {
          uploadFile.status = 'incomplete';
          const res = await this.$emit('upload', uploadFile.file, { noDisplayLoading: true });
          console.log(res);
          uploadFile.status = 'complete';
        } catch (err) {
          uploadFile.status = 'failed';
        }
      }
      // ファイルリスト再取得
      this.$store.dispatch('view/start')
      let retryCount = 0;
      while(!this.isUploadFinished) {
        if (3 < retryCount) break;
        if (retryCount === 0) sleep(500);
        await this.$emit('refresh', { noDisplayLoading: true });
        await sleep(1000);
        retryCount = retryCount + 1; 
      }
      // 工事データ更新
      const args = {
        cloud_construction_id: this.$route.params.cloudConstructionId,
        update_items: {
          user_s3data_byte: this.fileListSize
        },
        __apiOptions: {
          noDisplayLoading: true
        }
      }
      this.$store.dispatch('api/updateCloudConstruction', args).then((result) => {
        console.log(result);
        // TODO メッセージとか、使用容量とか出す?
      }).finally(() => {
        this.$store.dispatch('view/end')
      });
      this.isEnter = false;
    },
    formatLastModified(lastModified) {
      return moment(lastModified).format('Y/M/D');
    }
  }
}
</script>

<style scoped>
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
.wrap {
  padding: 3rem;
}
.title {
  border-bottom: solid 1px #333;
  font-size: 1.4rem;
  font-weight: bold;
  padding: 2rem 1rem;
}
.title a {
  color: #333;
  cursor: pointer;
  text-decoration: none;
}
.title a:hover {
  opacity: 0.8;
}
.files-wrap,
.upload-wrap {
  padding: 2rem 1rem;
}
.row {
  margin: 0.5rem 0;
  line-height: 2;
}
.file-name.head,
.modified-at.head {
  font-weight: bold;
}
.file-name {
  display: inline-block;
  vertical-align: top;
  margin-right: 1rem;
  width: 70%;
}
.modified-at,
.upload-status {
  display: inline-block;
  vertical-align: top;
  width: calc(30% -1rem);
}
.drop-area-wrap {
  padding: 1rem;
}
.drop-area {
  border: dashed 1px #999;
  color: #999;
  padding: 2rem;
  text-align: center;
}
.drop-area.enter {
  box-shadow: 0 0 1rem 0.5rem #ddd; 
}
.file-ref-btn-wrap {
  display: inline-block;
  margin-top: 1rem;
  position: relative;
}
.file-input {
  filter: alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  -webkit-appearance: none;
  appearance: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
input[type="file"],
input[type="file"]::-webkit-file-upload-button {
  cursor: pointer;
}
.file-ref-btn {
  background-color: #666;
  border: none;
  color: white;
  cursor: pointer;
  display: inline-block;
  padding: 0.5rem 2rem;
}
.file-input:focus + .file-ref-btn {
  box-shadow: 0 0 2px 2px #ccc;
}
.complete:after {
  content: "\02714";
  display: inline-block;
  vertical-align: middle;
  margin-left: 1rem;
  color: teal;
}
.failed:after {
  content: "\02715";
  display: inline-block;
  vertical-align: middle;
  margin-left: 1rem;
  color: crimson;
}
.incomplete:after {
  content: '';
  display: inline-block;
  position: relative;
  top: 0;
  left: 0;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 2px solid aliceblue;
  border-top: 2px solid lightskyblue;
  vertical-align: middle;
  margin-left: 1rem;
  animation: spinner .7s linear infinite;
}
</style>